import { render, staticRenderFns } from "./RC_report_center.vue?vue&type=template&id=226a7f0a&scoped=true"
import script from "./RC_report_center.vue?vue&type=script&lang=js"
export * from "./RC_report_center.vue?vue&type=script&lang=js"
import style0 from "./RC_report_center.vue?vue&type=style&index=0&id=226a7f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226a7f0a",
  null
  
)

export default component.exports